import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { getAccessToken, decodeJWTTokenPayload } from '@jutro/auth';
import { REQUEST_HANDLER_TYPE } from '../HttpRequestBuilder';
export var authTokenHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.AUTH, function _callee() {
  var accessToken;
  return _regeneratorRuntime.async(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(getAccessToken());

        case 2:
          accessToken = _context.sent;
          return _context.abrupt("return", {
            headers: {
              Authorization: "Bearer ".concat(accessToken),
              'GW-Tenant': decodeJWTTokenPayload(accessToken).tenant_id !== 'guidewire-hub' ? decodeJWTTokenPayload(accessToken).tenant_id : decodeJWTTokenPayload(accessToken).temp_tenant_id
            }
          });

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
});